import React from 'react';
import Image from 'pages/Dashboard/components/Image';
import ToolTip from 'core/components/Tooltip';
import {
  getColorForUnique,
} from 'utils/colors';
import {
  useUserProfilePicturePath,
} from 'pages/Dashboard/hooks/media';

type Props = {
  name: string;
  initials: string;
  userId: number;
};

export default function ProviderInitialsBadge({
  name,
  initials,
  userId,
}: Props) {
  const src = useUserProfilePicturePath(userId);

  return (
    <ToolTip title={name} placement="bottom">
      <span className="inline-flex">
        <Image
          size="xs"
          variant="rounded"
          className="font-semibold shrink-0 !shadow-sm ring-1 ring-white/80"
          color={getColorForUnique(String(userId))}
          alt={name}
          src={src}
        >
          <span className="text-[10px] leading-none text-white">
            {initials}
          </span>
        </Image>
      </span>
    </ToolTip>
  );
}
